<template>
    <div style="height: 100%;">
        <div class="bg" :style="{backgroundImage:'url('+loginbg+')'}"></div>
        <div class="mainbgm">
            <div style="height: 100%;min-width: 880px">
                <div style=" height: calc(100vh - 200px); min-height: 540px" >
                    <div style="height:120px; display: flex;color: white;justify-content: space-between">
                        <img :src="loginlogo" alt="" style="height: 40px;padding: 30px 60px;">
                        <div class="lang"  style="padding: 30px 60px;">
<!--                            <span>{{ $t('langsetting') }}</span>-->
                                <span class="langbox" v-for="item in langList" @click="langChange(item.i_id)">{{item.vc_name}}</span>

<!--                            <el-select v-model="vc_lang" style="width: 120px;margin-left: 8px" size="mini" @change="langChange" >-->
<!--                                <el-option-->
<!--                                        v-for="item in langList"-->
<!--                                        :key="item.i_id"-->
<!--                                        :label="item.vc_name"-->
<!--                                        :value="item.i_id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
                        </div>
                    </div>
                    <div class="mainlogin">
                        <div class="ying" v-if="baseerp=='ghw'"></div>

                        <div class="loginfontColor">
                            <h2 class="fontColor">{{ $t('login_title') }}</h2>
                            <h3 v-if="baseerp=='havay'">HAVAY Group</h3>
                            <h3 v-else>GHW International</h3>

                            <div style="margin-bottom:4px ">"Grow with customers" and look forward to</div>
                            <div>working together with more friends!</div>
                        </div>
                        <!--登录-->
                        <div class="loginform" v-if='!findPs'>
                            <div style="display: flex;justify-content: space-between;border-bottom: 1px solid #d6d4d4;">
                                <div class="usercode" :class="[active==true?'active logincolor':'']">
                                {{ $t('login_accountLogin') }}
                                </div>

                            </div>
                            <!--用户名登录-->
                            <el-form ref="formlogin" :model="formlogin" :rules="rules"
                                     style="padding: 20px 0 0 0;position: relative"
                                     v-show="temp">
                                <el-form-item prop="vc_login">
                                    <el-input v-model="formlogin.vc_login" :placeholder="$t('login_userName')"
                                              prefix-icon="el-icon-user" :disabled="disabled" @change="changeName"></el-input>
                                </el-form-item>
                                <el-form-item prop="vc_pwd" v-show="!isset">
                                    <el-input v-model="formlogin.vc_pwd" :placeholder="$t('login_password')" type="password"
                                              prefix-icon="el-icon-lock"></el-input>
                                </el-form-item>
                                <el-form-item class="code" v-show="!isset&&showyzm">
                                    <el-input v-model="formlogin.vc_yzm" :placeholder="$t('login_yzm')" style="width: 48%"></el-input>
                                    <el-button type="button" @click="getyzm" style="margin: 0 0 0 10px;width: 48%"
                                               v-if="show" >
                                        {{$t('login_sendYzm')}}
                                    </el-button>
                                    <el-button type="button" @click="getyzm" style="margin: 0 0 0 10px;width: 48%" v-else
                                               :disabled="true" class="disabledbtn">
                                        {{$t('login_tips_try_again',{time:time})}}
                                    </el-button>
                                </el-form-item>
                                <el-form-item prop="" v-show="!isset">
                                    <div style="display: flex;justify-content: flex-end;margin-top: -15px;margin-bottom: -10px">
                                        <div @click="getpwd" style="cursor: pointer" class="logincolor">
                                            {{$t('login_forgotPs')}}
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="" v-show="!isset">
                                    <el-button type="primary" @click="oncommit('formlogin')" class="login loginbtn">{{$t('login_logOn')}}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                            <!--手机号登录-->
                            <!--<el-form ref="formphone" :model="formphone" :rules="rulesphone" style="padding:35px 0px 20px;"
                                     v-show="!temp">
                                <el-form-item prop="vc_mobile">
                                    <el-input v-model="formphone.vc_mobile" placeholder="手机号"></el-input>
                                </el-form-item>

                                <el-form-item class="code" prop="vc_code">
                                    <el-input v-model="formphone.vc_code" placeholder="验证码" style="width: 48%"></el-input>

                                    <el-button type="button" @click="sendcode" style="margin: 0 0 0 10px;width: 48%"
                                               :disabled="!show" :class="issend?'disabledbtn':''">
                                        {{btntitle}}
                                    </el-button>
                                </el-form-item>
                                <div style="height: 60px"></div>
                                <el-form-item>
                                    <el-button type="primary" @click="commitphone('formphone')" class="loginbtn">登录
                                    </el-button>
                                </el-form-item>
                            </el-form>-->
                        </div>
                        <!--修改密码-->
                        <div class="loginform"v-if='findPs'>
                            <div style="display: flex;justify-content: space-between;border-bottom: 1px solid #d6d4d4;">
                                <div class="usercode" :class="[active==true?'active logincolor':'']">
                                    {{ $t('getpassword_title') }}
                                </div>

                            </div>
                            <find-password @close="psClose"></find-password>
                        </div>
                    </div>
                </div>
                <div class="footbox">
                    <div class="footdiv">
<!--                        <div class="flex">-->
<!--                            <div>-->
<!--                                <div class="linefoot">网站导航</div>-->
<!--                                <div>企业官网</div>-->
<!--                                <div>电商平台</div>-->
<!--                                <div>使用指南</div>-->
<!--                            </div>-->
<!--                            <div>-->
<!--                                <div class="linefoot" style="width: 90px">联系我们</div>-->
<!--                                <div>咨询电话：400-928-8777</div>-->
<!--                                <div v-if="baseerp=='ghw'">地址：江苏省南京市建邺区奥体大街69号06栋二，三层</div>-->
<!--                                <div v-else>地址：山东省泰安市大汶口石膏工业园</div>-->
<!--                            </div>-->
<!--                            <div>-->
<!--                                <div class="linefoot" style="width: 90px">关注我们</div>-->

<!--                            </div>-->
<!--                        </div>-->
                        <div style="text-align: center;">All rights reserved by Nanjing Goldenhighway Int'L SCM Corp</br><a href="https://beian.miit.gov.cn/#/Integrated/index" style="padding-left: 5px" target="new">苏ICP备05031427号-1</a></div>

                    </div>
                    <div class=" footbg"></div>

                </div>

            </div>
         </div>
        <!--<el-dialog title="设置密码" :visible.sync="dialogFormVisible" width="20%" height="300px"
                   :close-on-click-modal="false" @close="dialogClose">
            &lt;!&ndash;设置新密码&ndash;&gt;
            <el-form ref="formpwd" :model="formpwd" label-width="80px" class="setform"
                     style="padding: 35px 0px 20px;">
                <el-form-item prop="vc_login">
                    <el-input v-model="formpwd.vc_login" placeholder="用户名"
                              prefix-icon="el-icon-user" disabled></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="formpwd.password" placeholder="设置密码" type="password"
                              prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item prop="verifypwd">
                    <el-input v-model="formpwd.verifypwd" placeholder="确认密码" type="password"
                              prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="getvalidate('formpwd')">保存</el-button>
            </div>
        </el-dialog>
-->
    </div>

</template>

<script>
    import * as API from "./api";
    // import {languages} from './language'
    // import zh_cn from "@/locales/login_zh_cn";
    // import en_us from "@/locales/login_en_us";
    // import vi_vn from "@/locales/login_vi_vn";
    import md5 from 'js-md5';
    import { mapState } from "vuex"
    import {baseerp} from "@/utils/baseUrl";
    import {language} from '@/locales/selection'
    import FindPassword from '../getpassword'
    export default {
        name: 'Home',
        data() {
            return {
                // languages:require('@/locales/login_'+sessionStorage.getItem("vc_lang")),
                baseerp:'',//公共样式
                loginbg:'',
                loginlogo:'',
                issend: false,
                findPs: false,
                flag: false,
                temp: true,
                isSuccess: "false",
                disabled:false,
                btntitle: "login_sendYzm",
                timer: null,
                time: 0,
                isset: false,
                dialogFormVisible: false,
                formlogin: {
                    vc_login: "",
                    vc_pwd: "",
                    vc_yzm:"",
                    vc_mobile: "",
                    vc_code: "",
                },
                formphone: {
                    vc_mobile: "",
                    vc_code: "",
                },
                formpwd: {
                    vc_login: '',
                    password: '',
                    verifypwd: '',
                },
                show: true,
                active: true,
                rules: {
                    vc_login: [
                        {required: true, message: this.$t('login_tips_username_empty'), trigger: 'blur'},
                    ],
                    vc_pwd: [
                        {required: true, message:  this.$t('login_tips_ps_empty'), trigger: 'blur'},
                    ],
                },
                rulesphone: {
                    vc_mobile: [
                        {required: true, message: this.$t('login_tips_number_empty'), trigger: 'blur'},
                        {
                            type: 'number',
                            message: this.$t('login_the_format_of_the_phone_number_is_incorrect'),
                            trigger: 'blur',
                            transform(value) {
                                var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
                                if (!phonereg.test(value)) {
                                    return false
                                } else {
                                    return Number(value)
                                }
                            }
                        }
                    ],
                    vc_code: [
                        {required: true, message:  this.$t('login_tips_yzm_empty'), trigger: 'blur'},
                    ],
                },
                showyzm:false,
                langList:[],
                vc_lang:sessionStorage.getItem("vc_lang")
            }
        },
        watch: {
            /*isSuccess(val) {
                if (val) {
                    this.getcommit()
                }
            }*/
        },
        components:{FindPassword},
        computed:{
            ...mapState(["set_active_index","set_routerList_clear"])
        },
        mounted(){
            if(sessionStorage.getItem("vc_lang")){
                this.vc_lang=sessionStorage.getItem("vc_lang");

            }else{
                sessionStorage.setItem("vc_lang",'zh_cn')
                this.vc_lang='zh_cn'
            }
            // if(this.vc_lang=='zh_cn'){
                this.$i18n.mergeLocaleMessage(this.vc_lang,this.languages)
            //
            // }else if(this.vc_lang=='en_us'){
            //     this.$i18n.mergeLocaleMessage(this.vc_lang,en_us)
            //
            // }else if(this.vc_lang=='vi_vn'){
            //     this.$i18n.mergeLocaleMessage(this.vc_lang,vi_vn)
            //
            // }

            // this.langs=languages[this.vc_lang]
            this.baseerp=baseerp
            this.langList=language;
            // this.loginbg=require('../../assets/login_bg.png')
            this.loginbg=require('../../assets/login_bg_'+baseerp+'.jpg')
            this.loginlogo=require('../../assets/login_logo_overseas.png')
            // this.loginlogo=require('../../assets/login_logo_'+baseerp+'.png')

            sessionStorage.removeItem("name");
            sessionStorage.removeItem("userid")
            sessionStorage.removeItem("token")
            sessionStorage.removeItem("userType")
            sessionStorage.removeItem("userType")
            sessionStorage.removeItem("mids");
            this.changeName();
            // window.addEventListener('unload', this.saveState)
        },
        methods: {
            langChange(val){
                if( this.vc_lang!=val){
                    this.vc_lang=val
                    sessionStorage.setItem("vc_lang", this.vc_lang);
                    this.$i18n.locale=this.vc_lang;
                    let title=this.$t('menu_index')
                    let str={ path: '/home/desk.vue',
                        name: 'home/desk.vue',
                        component: () => import('@/views/home/desk.vue'),
                        meta:{title:title}
                    };
                    // console.log(this.$t('menu_index'),str, this.vc_lang,'-------------------')
                    sessionStorage.setItem('routerList', JSON.stringify([str]));
                    sessionStorage.setItem('activeIndex','home/desk.vue')
                    this.$store.commit('set_routerList_clear',str)
                    this.$router.push({ path: "/home/desk.vue" });
                    this.$i18n.mergeLocaleMessage(this.vc_lang,this.languages)

                    // if(this.vc_lang=='zh_cn'){
                    //     this.$i18n.mergeLocaleMessage(this.vc_lang,zh_cn)
                    //
                    // }else if(this.vc_lang=='en_us'){
                    //     this.$i18n.mergeLocaleMessage(this.vc_lang,en_us)
                    //
                    // }else if(this.vc_lang=='vi_vn'){
                    //     this.$i18n.mergeLocaleMessage(this.vc_lang,vi_vn)
                    //
                    // }
                    location.reload()
                }
            },
            //切换
            change: function (t, formName) {
                this.temp = t;
                this.active = t;
                this.$refs[formName].resetFields();
            },
            touchStartEvent(e) {

            },
            changeName(val){
                this.oldName=localStorage.getItem("loginuser")
                if (val==localStorage.getItem("loginuser")){
                    this.showyzm=false
                }else {
                    this.showyzm=true
                }
                // console.log(val,"val",sessionStorage.getItem("loginuser"))
            },
           /* // 拼图成功
            onSuccess() {
                this.isSuccess = true;
                this.flag = false;
            },
            // 拼图失败
            onFail() {
                this.isSuccess = false;
            },
            // 拼图刷新
            onRefresh() {
            },*/
            getpwd() {
                this.findPs=true
                // this.$router.push('./getpassword');
            },
            psClose() {
                this.findPs=false
                // this.$router.push('./getpassword');
            },
            dialogClose() {
                //移除校验结果并重置字段值
                this.$refs.formpwd.resetFields();
            },
            //获取验证码
            async getyzm() {
                let param = {
                    vc_login: this.formlogin.vc_login,
                    type: 1,
                };
                let res = await API.sendVerficationCode(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.show = false;
                } else {
                    this.$message.error(res.message);
                }
                this.time = 60;
                let timer = setInterval(() => {
                    if (this.time == 0) {
                        clearInterval(timer);
                        this.btntitle = 'login_sendYzm';
                        this.show = true;
                        this.issend = false
                    } else {
                        this.issend = true
                        this.btntitle =this.time+this.$t('login_tips_try_again');
                        this.time--;
                        this.show = false;
                    }
                }, 1000)
            },
            //帐号登录
            async oncommit(formRef) {
                /*sessionStorage.removeItem("name");
                sessionStorage.removeItem("userid")
                sessionStorage.removeItem("token")
                sessionStorage.removeItem("userType")
                sessionStorage.removeItem("userType")
                sessionStorage.removeItem("mids");*/
                let valid = this.$formRulesValidate({ref: formRef, example: this});
                if (!valid) {
                    return;
                }
                if (this.formlogin.vc_login??''!==''){
                    if (this.formlogin.vc_login == localStorage.getItem("loginuser")){
                        this.getcommit();
                    }else {
                        if (this.formlogin.vc_yzm ?? '' !== '') {
                            let param = {
                                vc_login: this.formlogin.vc_login,
                                vc_code: this.formlogin.vc_yzm,
                                type: 1,
                            };
                            let res = await API.validateCode(param);
                            if (res.code == 1) {
                                // this.$message.success(res.message);
                                this.getcommit()
                            } else {
                                this.$message.error(res.message);
                                this.formlogin.vc_yzm = "";
                            }
                        } else {
                            this.$message.error(this.$t('login_please_enter_the_verification_code'));

                        }
                    }
                }else{
                    this.$message.error(this.$t('login_enter_one_user_name'));
                }


                /*let valid = this.$formRulesValidate({ref: formRef, example: this});
                if (!valid) {
                    return;
                }
                if (this.formlogin.vc_login === "" || this.formlogin.vc_pwd == "") {
                    this.flag = false;
                } else {
                    this.flag = true;
                }*/
            },

            //手机登录
           /* async commitphone(formRef) {
                this.$refs[formRef].validate(async valid => {
                    if (valid) {
                        let param = {
                            vc_code: this.formphone.vc_code,
                            vc_mobile: this.formphone.vc_mobile,
                            type: 1,
                        };
                        let res = await API.getlogin(param);
                        if (res.code == 1) {
                            this.$message.success(res.message);
                            localStorage.setItem("loginuser", res.userName);
                            sessionStorage.setItem("loginuser", res.userName);
                            sessionStorage.setItem("name", res.name);
                            sessionStorage.setItem("userid", res.userId);
                            sessionStorage.setItem("token", res.token);
                            sessionStorage.setItem("userType", res.userType);
                            sessionStorage.setItem("lruname", res.userName);
                            sessionStorage.setItem("uuid", res.uuid);
                            sessionStorage.setItem("i_gid", res.gid);
                            if(this.oldName!==localStorage.getItem("loginuser")){
                                let str={ path: '/home/desk.vue',
                                    name: 'home/desk.vue',
                                    component: () => import('@/views/home/desk.vue'),
                                    meta:{title:"首页"}

                                };
                                sessionStorage.setItem('routerList', JSON.stringify([str]));
                                sessionStorage.setItem('activeIndex','home/desk.vue')
                                this.$store.commit('set_routerList_clear',str)
                                this.$store.commit('set_active_index','home/desk.vue')
                            }
                            this.$router.push('/')
                        } else if (res.code == -13) {
                            this.$confirm(res.message, '友情提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$router.push('/login');
                            })
                        } else {
                            this.$message.error(res.message);
                            this.formphone.vc_code = "";
                        }
                    } else {
                        return false;
                    }
                });
            },
            *///验证码校验
            async sendcode() {
                var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
                if (this.formphone.vc_mobile == "") {
                    this.$message.error(this.$t('login_tips_number_empty'));
                } else if (!reg.test(this.formphone.vc_mobile)) {
                    this.$message.error(this.$t('login_tips_incorrect_number'));
                    this.formphone.vc_mobile = ""
                    return false;
                } else {
                    this.getcode();
                    this.time = 60;
                    let timer = setInterval(() => {
                        if (this.time == 0) {
                            clearInterval(timer);
                            this.btntitle = 'login_sendYzm';

                            this.show = true;
                            this.issend = false
                        } else {
                            this.issend = true
                            this.btntitle = this.time  +this.$t('login_tips_try_again');
                            this.time--;
                            this.show = false;
                        }
                    }, 1000)
                }
            },


            //登录方法
            async getcommit() {
                const loading = this.$loading({
                    lock: true,
                    text: this.$t('login_logging_in'),
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                /*var md = md5(this.formlogin.vc_login + this.formlogin.vc_pwd);*/
                var md = md5(this.formlogin.vc_pwd);
                let param = {
                    vc_login: this.formlogin.vc_login,
                    vc_pwd: md.toUpperCase(),
                };
                let res = await API.getlogin(param);
                if (res.code == 1) {
                    // console.log(res.uuid)
                    loading.close();
                    this.$message.success(res.message);
                    localStorage.setItem("loginuser", res.userName);
                    sessionStorage.setItem("loginuser", res.userName)
                    sessionStorage.setItem("name", res.name);
                    sessionStorage.setItem("userid", res.userId)
                    sessionStorage.setItem("token", res.token)
                    sessionStorage.setItem("userType", res.userType)
                    // sessionStorage.setItem("vc_lang",res.vc_language)
                    sessionStorage.setItem("lruname", res.userName);
                    sessionStorage.setItem("uuid", res.uuid);
                    sessionStorage.setItem("i_gid", res.gid);
                    if(this.oldName!==localStorage.getItem("loginuser")){
                        let str={ path: '/home/desk.vue',
                            name: 'home/desk.vue',
                            component: () => import('@/views/home/desk.vue'),
                            meta:{title:this.$t('menu_index')}

                        };
                        sessionStorage.setItem('routerList', JSON.stringify([str]));
                        sessionStorage.setItem('activeIndex','home/desk.vue')
                        this.$store.commit('set_routerList_clear',str)
                        this.$store.commit('set_active_index','home/desk.vue')
                    }
                    this.$store.commit('changeLogin','login')
                    this.$router.push('/')
                } else if (res.code == -13) {
                    loading.close();
                    this.$confirm(res.message, this.$t('tips_confirm_exit_tips'), {
                        confirmButtonText: this.$t('button_sure'),
                        cancelButtonText: this.$t('button_cancel'),
                        type: 'warning'
                    }).then(() => {
                        this.$router.push('/');
                    }).catch(() => {
                        this.$router.push('/');
                    })
                    sessionStorage.setItem("loginuser", res.userName)
                    localStorage.setItem("loginuser", res.userName);
                    sessionStorage.setItem("userid", res.userId)
                    sessionStorage.setItem("name", res.name);
                    sessionStorage.setItem("token", res.token)
                    sessionStorage.setItem("userType", res.userType)
                    sessionStorage.setItem("lruname", res.userName);
                    // sessionStorage.setItem("vc_lang",res.vc_language)
                    sessionStorage.setItem("uuid", res.uuid);
                    sessionStorage.setItem("i_gid", res.gid);
                    this.$store.commit('changeLogin','login')
                    if(this.oldName!==localStorage.getItem("loginuser")){
                        let str={ path: '/home/desk.vue',
                            name: 'home/desk.vue',
                            component: () => import('@/views/home/desk.vue'),
                            meta:{title:this.$t('menu_index')}

                        };
                        sessionStorage.setItem('routerList', JSON.stringify([str]));
                        sessionStorage.setItem('activeIndex','home/desk.vue')
                        this.$store.commit('set_routerList_clear',str)
                        this.$store.commit('set_active_index','home/desk.vue')
                    }
                } else if (res.code == 3) {
                    loading.close();
                    this.$confirm(res.message, this.$t('tips_confirm_exit_tips'), {
                        confirmButtonText: this.$t('button_sure'),
                        cancelButtonText: this.$t('button_cancel'),
                        type: 'warning'
                    }).then(() => {
                        this.formpwd.vc_login = this.formlogin.vc_login;
                        this.formlogin.vc_mobile = res.vc_mobile;
                        this.isset = true;
                        this.isSuccess = false;
                        this.disabled=true;
                    }).catch(() => {
                        this.isSuccess = false;
                    })
                } else {
                    loading.close();
                    this.$message.error(res.message);
                    this.flag = false;
                    this.isSuccess = false;
                    this.formlogin = {
                        vc_login: "",
                        vc_pwd: "",
                    }
                }
            },
            //获取验证码
            async sendsetcode() {
                let param = {
                    vc_mobile: this.formlogin.vc_mobile,
                    type: 3,
                };
                let res = await API.sendVerficationCode(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.show = false;
                } else {
                    this.$message.error(res.message);
                }
                this.time = 60;
                let timer = setInterval(() => {
                    if (this.time == 0) {
                        clearInterval(timer);
                        this.btntitle = "login_sendYzm";
                        this.show = true;
                        this.issend = false
                    } else {
                        this.issend = true
                        this.btntitle = this.time +this.$t('login_tips_try_again');
                        this.time--;
                        this.show = false;
                    }
                }, 1000)
            },

            async getcode() {
                let param = {
                    vc_mobile: this.formlogin.vc_mobile,
                    type: 3,
                };
                let res = await API.sendVerficationCode(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.show = false;
                } else {
                    this.$message.error(res.message);
                }
                this.time = 60;
                let timer = setInterval(() => {
                    if (this.time == 0) {
                        clearInterval(timer);
                        this.btntitle = "login_sendYzm";
                        this.show = true;
                        this.issend = false
                    } else {
                        this.issend = true
                        this.btntitle = this.time +this.$t('login_tips_try_again');
                        this.time--;
                        this.show = false;
                    }
                }, 1000)
            },
            //下一步设置密码
            // async commitset() {
            //     if(this.formlogin.vc_code==""){
            //         this.$message.error(+this.$t('login_please_fill_in_the_correct_verification_code'));
            //     }else {
            //     let param = {
            //         vc_mobile: this.formlogin.vc_mobile,
            //         vc_code: this.formlogin.vc_code,
            //         type: 3,
            //     };
            //     let res = await API.validateCode(param);
            //     if (res.code == 1) {
            //         this.$message.success(res.message);
            //         this.dialogFormVisible = true;
            //
            //     } else {
            //         this.$message.error(res.message);
            //         this.formlogin.vc_code = "";
            //     }
            //     }
            // },
            // 设置密码
            async getvalidate(formpwd) {
                var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
                if (this.formpwd.password == "") {
                    this.$message.error(this.$t('login_password_cannot_be_empty'));
                } else if (!regex.test(this.formpwd.password)) {
                    this.$message.error(this.$t('login_the_password_must_be_greater_than_6_characters_and_contain_numbers_and_letters'));
                    this.formpwd.password = "";
                    this.formpwd.verifypwd = "";
                } else if (this.formpwd.verifypwd == "") {
                    this.$message.error(this.$t('login_confirm_password_cannot_be_empty'));
                } else if (this.formpwd.password !== this.formpwd.verifypwd) {
                    this.$message.error(this.$t('login_two_passwords_are_inconsistent'));
                    this.formpwd.password = "";
                    this.formpwd.verifypwd = "";
                } else {
                    var mdpwd = md5(this.formlogin.vc_login + this.formpwd.password)
                     //console.log(mdpwd)
                    let param = {
                        vc_mobile: this.formlogin.vc_mobile,
                        vc_pwd: mdpwd.toUpperCase(),
                    };
                    let res = await API.setpwd(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        this.isset = false;
                        this.dialogFormVisible = false;
                        this.formlogin.vc_pwd = "";
                        this.disabled=false;
                    } else {
                        this.$message.error(res.message);
                        this.formphone.password = "";
                        this.formpwd.verifypwd = "";
                    }
                }
            },
        },

    }
</script>
<style lang="scss">
    body {
        margin: 0 !important;
    }
    .out{
        height: 100%;
        min-height: 960px;
        overflow-y: auto;
    }
    .bg{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -2;
        /*background: url("../../assets/login_bg.png");*/
        background-size: cover;
        background-position: center;
        height: 100%;
    }
    .mainbgm {
        height: 100vh;

        /*display: flex;*/
        flex-direction: column;
        overflow: auto;
        .langbox{
            /*display: inline-block;*/
            padding: 0 9px;
            border-right: 2px solid white;
            cursor: pointer;
        }
        .lang span.langbox:last-child{
            border-right:none;

        }
        .disabledbtn {
            background: #f6f6f6 !important;
            color: #666 !important;
        }

        .active {
            /*color: #E89112;*/
            /*border-bottom: 2px solid;*/
            font-weight: bold;
        }

        .el-input__icon {
            color: #000;
            font-size: 16px;
        }
        .footbox{
            position: fixed;
            width: 100%;
            bottom: 0;
            /*height: 200px;*/
        }
        .footdiv {
            position: relative;
            z-index: 99;
            /*background: #af7e37;*/
            /*opacity: 0.66;*/
            color: var(--whiteColor);
            padding: 10px 100px 10px 100px;

        }
        .footbg{
            opacity: 0.4;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 2;
            height: 100%;
            background-color: var(--login_foot) ;
        }
        .flex{
            display: flex;
            flex: 1;
            justify-content: space-around;
        }
        .footdiv div {
            font-size: 13px;
            margin: 8px 0;
        }

        .linefoot {
            font-size: 15px !important;
            border-bottom: 1px solid var(--whiteColor);
            padding-bottom: 4px;
            opacity: 1;
        }
        .loginform {
            width: 350px;
            /*height: 350px;*/
            background: var(--whiteColor);
            padding: 30px 30px 10px 30px;
            background: var(--whiteColor);
            text-align: center;
            border-radius: 8px;
            /*box-shadow: 0 0 14px var(--dark);*/
        }

        .loginbtn {
            width: 100%;
            color: var(--whiteColor);

        }
        .loginfontColor{
            color: var(--login_title);
        }
        .mainlogin {
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0 auto;
            position: relative;
        }
        .ying{
            background: url("../../assets/ying.png");
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            position: fixed;
            z-index: -1;
            top: 30%;
            left: 34%;
            height: 200px;
            width: 300px;
        }
        h2 {
            margin: 90px 0 20px 0;
        }

        h3 {
            margin: 10px 0;
        }

        .usercode {
            padding: 0 0 10px 0;
            /*width: 40%;*/
            cursor: pointer;
        }

        .phone {
            width: 40%;
            cursor: pointer;
        }

        .code .el-form-item__content {
            display: flex;
            justify-content: space-between;
        }

        .el-input__inner ,.el-button{
            border-radius: 8px;
        }

        .slide-verify-slider {
            border-radius: 8px;
            background: #e5e4e4 !important;
            margin-top: 10px !important;
        }

        .slide-verify-slider-text {
            font-size: 13px;
            color: #666;
        }

        .slide-verify-slider-mask-item {
            border-radius: 8px;
        }

        /*.testCode {
            position: absolute;
            top: -35px;
            z-index: 99;
            background: var(--whiteColor);
            box-shadow: 0 0 2px 2px #eee;
        }*/

        .closeBtn {
            display: flex;
            justify-content: space-between;
        }

        .closetip {
            font-size: 14px;
            color: #666;
            padding: 0 10px;
        }

        .setform .el-form-item__content {
            margin-left: 0px !important;
        }
        /deep/{
            .el-button:focus, .el-button:hover {
                color: var(--dark);
                border-color: var(--light);
                background-color: var(--opacity);
            }
            .el-button:active {
                color: var(--dark);
                border-color: var(--dark);
            }
        }
    }
    .login{
        background-color: var(--dark);
        border: var(--dark);
        color: var(--whiteColor);
    }
    .logincolor,.havaylogincolor,.ghwlogincolor,.overseaslogincolor{
        color: var(--dark) !important;
    }
</style>
